import { z } from 'zod';
import { IsoDateTimeSchema, PaginationSchema, UuidSchema } from './common.js';
// @db.Date: entrada YYYY-MM-DD (regex strict — evita rollover de timezone, pitfall P-010/11).
export const DateOnlySchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'invalid_date');
export const LicenciaSchema = z.object({
    id: UuidSchema,
    guardiaId: UuidSchema.nullable(),
    empresaId: UuidSchema.nullable(),
    empresaVisepId: UuidSchema.nullable(),
    tipoPropietario: z.string().max(50).nullable(),
    tipo: z.string().max(100).nullable(),
    numero: z.string().max(100).nullable(),
    fechaEmision: IsoDateTimeSchema.nullable(),
    fechaVencimiento: IsoDateTimeSchema.nullable(),
    estado: z.string().max(50).nullable(),
    archivoUrl: z.string().max(1000).nullable(),
    notas: z.string().max(2000).nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
});
const licenciaMutable = {
    guardiaId: UuidSchema.nullable().optional(),
    empresaId: UuidSchema.nullable().optional(),
    empresaVisepId: UuidSchema.nullable().optional(),
    tipoPropietario: z.string().max(50).nullable().optional(),
    tipo: z.string().max(100).nullable().optional(),
    numero: z.string().max(100).nullable().optional(),
    fechaEmision: DateOnlySchema.nullable().optional(),
    fechaVencimiento: DateOnlySchema.nullable().optional(),
    estado: z.string().max(50).nullable().optional(),
    archivoUrl: z.string().max(1000).nullable().optional(),
    notas: z.string().max(2000).nullable().optional(),
};
export const CreateLicenciaRequestSchema = z.object({ ...licenciaMutable });
export const UpdateLicenciaRequestSchema = z.object({ ...licenciaMutable });
export const LicenciaListQuerySchema = PaginationSchema.extend({
    estado: z.string().max(50).optional(),
    tipoPropietario: z.string().max(50).optional(),
    venceAntes: DateOnlySchema.optional(),
});
export const EmpresaSchema = z.object({
    id: UuidSchema,
    nombre: z.string().min(1).max(200),
    ruc: z.string().max(50).nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
});
export const CreateEmpresaRequestSchema = z.object({
    nombre: z.string().min(1).max(200),
    ruc: z.string().max(50).nullable().optional(),
});
export const UpdateEmpresaRequestSchema = z.object({
    nombre: z.string().min(1).max(200).optional(),
    ruc: z.string().max(50).nullable().optional(),
});
export const EmpresaListQuerySchema = PaginationSchema;
export const EmpresaVisepSchema = z.object({
    id: UuidSchema,
    empresaId: UuidSchema,
    visepNumero: z.string().max(100).nullable(),
    descripcion: z.string().max(500).nullable(),
    estado: z.string().max(50).nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
});
export const CreateEmpresaVisepRequestSchema = z.object({
    empresaId: UuidSchema,
    visepNumero: z.string().max(100).nullable().optional(),
    descripcion: z.string().max(500).nullable().optional(),
    estado: z.string().max(50).nullable().optional(),
});
export const EmpresaVisepListQuerySchema = PaginationSchema.extend({
    empresaId: UuidSchema.optional(),
});
//# sourceMappingURL=licencias.js.map